import { toast } from "sonner";

// Ejecuta una acción específica de un asunto. Algunas acciones abren el detalle
// (navegación) y otras muestran una respuesta de demostración (toast).
export const runMatterAction = (label, matter, navigate) => {
  switch (label) {
    case "Ver detalle":
    case "Ver opciones":
    case "Ver cita":
      navigate(`/asunto/${matter.id}`);
      return;

    case "Cómo renovarlo":
      toast.info("Cómo renovar tu certificado digital", {
        description:
          "1) Entra en la sede de la FNMT con el certificado en vigor. 2) Solicita la renovación online. 3) Descárgalo e instálalo. Puedo recordártelo con antelación.",
        duration: 7000,
      });
      return;

    case "Preparar correo":
      toast.success("Borrador de correo preparado", {
        description:
          "He redactado un correo para solicitar la revisión de la prima. Podrás revisarlo y editarlo antes de enviar nada.",
        duration: 6000,
      });
      return;

    case "Preparar cita":
      toast.success("Cita preparada", {
        description:
          "He reunido los documentos que tienes guardados para esta cita. Revisa si la consulta te ha pedido aportar algo más.",
        duration: 6000,
      });
      return;

    case "Recordármelo":
      toast.success("Recordatorio creado", {
        description: `Te avisaré sobre "${matter.title}" con suficiente antelación.`,
        duration: 5000,
      });
      return;

    default:
      navigate(`/asunto/${matter.id}`);
  }
};
